export default __webpack_public_path__ + "static/media/esFlag.7b5666a7.svg";